import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=134f8d25&scoped=true&"
import script from "./ItemImage.vue?vue&type=script&lang=js&"
export * from "./ItemImage.vue?vue&type=script&lang=js&"
import style0 from "./ItemImage.vue?vue&type=style&index=0&id=134f8d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f8d25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
